<template>
  <div class="detBg" :style="defSty">
    <div class="main">
      <div class="mask-view">
        <div class="title-bar">我的选书</div>
        <book-table
          class="table"
          :dataList="bookList"
          :isShowStatus="false"
          :submitSuccess="submitSuccess"
          @deleteDone="deleteDone"
        ></book-table>
      </div>
    </div>
    <div class="mask-bg" v-if="isShowView">
      <div class="submit-modal">
        <div class="submit-head">
          <div class="close-btn" @click="hideModal">
            <img
              class="close-image"
              src="../../assets/img/close-white.png"
              alt=""
            />
          </div>
        </div>
        <div class="content">
          <img
            class="success-image"
            src="../../assets/img/success.png"
            alt=""
          />
          <div class="success-text">书单已提交成功，请等待校领导审核</div>
          <div class="success-btn" @click="goHome">返回首页</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BookTable from './common/book-table'
import AddBook from '../common/model'
import { cartBookList } from '../../api/wapi'
Vue.component('book-table', BookTable)
Vue.component('add-book', AddBook)
export default {
  data() {
    return {
      defSty: {
        height: `${document.documentElement.clientHeight-100}px`,
      },
      isShowView: false,
      bookList: [],
      checked: false,
    }
  },
  provide() {
    return {
      updateList: this.updateList,
    }
  },
  methods: {
    updateList() {
      this.getCartBook()
    },
    deleteDone(index) {
      this.bookList.splice(index, 1)
    },
    goHome() {
      this.$router.push('/')
    },
    hideModal() {
      this.isShowView = false
    },
    // 提交成功
    submitSuccess() {
      this.getCartBook()
      this.isShowView = true
    },
    getCartBook() {
      cartBookList().then((res) => {
        if (res.status == 0) {
          var list = res.data
          list.forEach((element) => {
            element.isEidt = true
          })
          this.bookList = list
        }
      })
    },
  },
  watch: {
    $route(to, from) {
      this.selectedActive = to.path
    },
  },
  created() {
    this.getCartBook()
  },
}
</script>

<style lang="scss" scoped>
.detBg {
  background-color: #f8f8f8;
}
.right-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit-btn {
  background-color: #0082F0;
  color: white;
  height: 56px;
  text-align: center;
  line-height: 56px;
  width: 100px;
}
.msg {
  font-size: 13px;
  color: #333333;
  margin-right: 10px;
}
.main {
  // background-color: white;
}
.title-bar {
  padding-top: 21px;
  padding-bottom: 12px;
  color: #0082F0;
  font-size: 1px;
}
.mask-view {
}
.submit-bg {
  width: 1040px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit-mask {
  position: absolute;
  display: flex;
  bottom: 80px;
  left: 0px;
  right: 0px;
  height: 56px;
  z-index: 0;
  background-color: white;
  -moz-box-shadow: 0px -4px 10px 0px rgba($color: #000000, $alpha: 0.15);
  -webkit-box-shadow: 0px -4px 10px 0px rgba($color: #000000, $alpha: 0.15);
  box-shadow: 0px -4px 10px 0px rgba($color: #000000, $alpha: 0.15);
}
/* 提交成功弹框 */
.mask-bg {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 100;
}
.submit-modal {
  margin-top: 200px;
  background-color: white;
  width: 380px;
  height: 300px;
}
.submit-head {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.close-btn {
  width: 44px;
  height: 44px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0082F0;
}
.close-image {
  width: 20px;
  height: 20px;
}
.content {
  margin: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
}
.success-image {
  margin-top: 19px;
  width: 48px;
  height: 48px;
}
.success-text {
  font-size: 14px;
  color: #333333;
  text-align: center;
  margin-top: 19px;
}
.success-btn {
  color: white;
  background-color: #0082F0;
  width: 96px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  margin: auto;
  margin-top: 50px;
}
</style>